import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend, ResponsiveContainer, Tooltip, XAxis, YAxis
} from 'recharts';

function GraphBlock(props) {
  const {
    type, chartData, handleClickCell
  } = props;

  switch (type) {
    case 'bar':
      return (
        <ResponsiveContainer
          width="100%"
          height="100%"
          aspect={1.2}
        >
          <BarChart
            width={600}
            height={500}
            data={chartData}
            layout="vertical"
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis width={150} padding={{ left: 20 }} dataKey="name" type="category" />
            <Tooltip />
            <Legend />
            <Bar
              dataKey="Subscribers Count"
              fill="#8884d8"
              onClick={handleClickCell}
            />
          </BarChart>
        </ResponsiveContainer>
      );
    default:
      return null;
  }
}

export default GraphBlock;
